module.exports = __webpack_public_path__ + "img/01020206.b37683a4.svg";